




















































































































































































































import { Vue, Component } from 'vue-property-decorator';
import {
  ValidationProvider as validationProvider,
  ValidationObserver as validationObserver,
  ValidationObserver,
} from 'vee-validate';
import popup from '@/components/layout/Popup.vue';
import popupHeader from '@/components/atomic/organisms/PopupHeader.vue';
import popupRadio from '@/components/atomic/organisms/PopupRadio.vue';
import dropdown from '@/components/atomic/atoms/Dropdown.vue';
import validateionTextField from '@/components/atomic/atoms/ValidationTextField.vue';

import ContactRepository from '@/lib/http/contact.ts';

@Component({
  name: 'ContactPopup',
  components: {
    popup,
    popupHeader,
    dropdown,
    popupRadio,
    validateionTextField,
    validationObserver,
    validationProvider,
  },
})
/**
 * @vuse
 * @group Atomic/Organisms
 * LoginPopup component
 */
export default class ContactPopup extends Vue {

  // [Data]
  $refs!: {
    form: InstanceType<typeof ValidationObserver>;
    contactVideo: any;
  };
  contents: Array<string> = [];
  listingDivs: Array<string> = [];

  displayPopup: boolean = false;

  firstname: string = '';
  lastname: string = '';
  name: string = '';
  email: string = '';
  phoneNumber: string = '';
  company: string = '';
  division: string = '';
  job: string = '';
  listingDiv: string = '';
  content: string = '';
  message: string = '';
  isSuccess: boolean = false;
  isFail: boolean = false;

  radio: string = 'business';
  // [Life cycle]
  created() {
    this.contents = [
      this.$t('contact.inquiry1').toString(),
      this.$t('contact.inquiry2').toString(),
      this.$t('contact.inquiry3').toString(),
      this.$t('contact.inquiry4').toString(),
      this.$t('contact.inquiry5').toString(),
      this.$t('contact.inquiry6').toString()
    ];

    this.listingDivs = [
      this.$t('contact.listing_division1').toString(),
      this.$t('contact.listing_division2').toString(),
      this.$t('contact.listing_division3').toString(),
    ];
  }

  // [Methods]
  changeValue(value: string) {
    this.company = value;
  }

  showPopup() {
    this.clearInput();
    this.displayPopup = true;
    this.radio="business"
  }

  clearInput() {
    this.name = '';
    this.firstname = '';
    this.lastname = '';
    this.email = '';
    this.phoneNumber = '';
    this.company = '';
    this.division = '';
    this.job = '';
    this.listingDiv = '';
    this.content = '';
    this.message = '';
  }

  clearInputR() {
    this.clearInput();
    this.$refs.form.reset();
  }

  sendContact() {
    this.isSuccess = !this.isSuccess;
    if (this.radio === 'business') {
      ContactRepository.sendContactCompany({
        company: this.company,
        business_name: this.division,
        job_name: this.job,
        first_name: this.firstname,
        last_name: this.lastname,
        email: this.email,
        phone: this.phoneNumber,
        listed_division: this.listingDiv,
        title: this.content,
        message: this.message
      }).then(() => {
        this.isFail = false;
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 3000);
        this.clearInputR();
      }).catch(() => {
        this.isSuccess = false;
        this.isFail = true;
      });
    } else {
      ContactRepository.sendContactIndividual({
        name: this.name,
        email: this.email,
        message: this.message,
      }).then(() => {
        this.isFail = false;
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 3000);
        this.clearInputR();
      }).catch(() => {
        this.isSuccess = false;
        this.isFail = true;
      });
    }
  }

  radioCheckValue(value: string) {
    this.radio = value;
  }

  changeForm(value: any) {
    if (this.radio === "business") {
      return true;
    }
    return false;
  }
}
